import { Link } from 'react-router-dom';

const comparisons = [
  {
    title: 'ATS Resume vs Traditional Resume',
    description: 'Why parsing-friendly structure beats decorative layouts for online applications.',
    to: '/blog/ats-resume-guide',
  },
  {
    title: 'Static vs Dynamic QR Codes',
    description: 'Permanence, analytics, and when to avoid redirect-based QR services.',
    to: '/blog/static-vs-dynamic-qr-codes',
  },
  {
    title: 'US to EU Shoe Sizes',
    description: 'Conversion tables, brand quirks, and measuring feet in centimeters.',
    to: '/blog/us-to-eu-shoe-size-conversion',
  },
];

export default function ToolComparisons() {
  return (
    <section className="py-20 px-4 border-t border-gray-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 text-center">Tool Comparisons & Guides</h2>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
          {comparisons.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="block rounded-2xl p-6 border border-gray-100 bg-white hover:border-brand-200 hover:shadow-md transition-all group"
            >
              <h3 className="font-semibold text-gray-900 group-hover:text-brand-600 transition-colors">{item.title}</h3>
              <p className="mt-2 text-sm text-gray-500">{item.description}</p>
              <span className="mt-4 inline-block text-sm text-brand-600 font-medium">Read guide →</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
